import CreateSandboxInstancePage from './CreateSandboxInstance';

export default function EditSandboxInstancePage() {
  return <CreateSandboxInstancePage />;
}
